import StoredLayout from '../../layouts/StoredLayout'
import Recharts from './Recharts'
export default StoredLayout(Recharts)



// WEBPACK FOOTER //
// ./src/charts/recharts/index.js